<template>
    <a v-bind="$attrs" :href="url" :download="filename" @click="handleClicked" v-loading.body="loading" :data-src="src">
        <slot></slot>
        <b-modal title="Échec du téléchargement du fichier" ok-only ref="alert" data-legacy>
            <b-alert v-if="error" show variant="danger" class="m-0">
                <slot v-if="error.response.status === 404" name="404">Fichier non trouvé</slot>
                <template v-else>Une erreur imprévue s'est produite</template>
            </b-alert>
        </b-modal>
    </a>
</template>

<script>
    import axios from 'axios';
    import { BModal, BAlert } from 'bootstrap-vue';

    export default {
        components: {
            BModal,
            BAlert,
        },
        props: {
            src: {
                type: String,
                required: true
            },
            filename: {
                type: String,
                required: true,
                default: ''
            }
        },
        data() {
            return {
                url: '',
                blob: null,
                error: null,
                loading: false
            }
        },
        computed: {
            resolved() { return !!this.url; }
        },
        methods: {
            async handleClicked(e) {
                if(this.resolved){
                    if (navigator.msSaveBlob) {
                        e.preventDefault();
                        navigator.msSaveBlob(this.blob, this.filename);
                    }
                    return;
                }
                this.loading = true;
                e.preventDefault();
                axios.get(this.src, { responseType:'blob' }).then(async res => {
                    this.blob = res.data;
                    this.url = URL.createObjectURL(this.blob);
                    await this.$nextTick();
                    this.$el.click();
                }).catch(error => {
                    this.error = error;
                    this.$refs.alert.show();
                }).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>
